function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import cn from 'classnames';
import { AppContext } from 'context';
import Chip from 'components/Chip';
import messages from '../../../../messages';
import styles from './HeaderBox.pcss';
const HeaderBox = ()=>{
    const { environmentName } = useContext(AppContext);
    useStyles(styles);
    return /*#__PURE__*/ _jsxs("div", {
        className: `col-auto ${styles.sidebar__headerContainer}`,
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.sidebar__headerContainer__top,
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            className: "text--h3",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebarHeader.backOffice))
                        }),
                        /*#__PURE__*/ _jsx(Chip, {
                            labelMessage: messages.sidebarHeader.env[environmentName],
                            styleModifier: "inactive"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: cn('text--small', 'text--disabled'),
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebarHeader.adminPanel))
            })
        ]
    });
};
export default HeaderBox;
